import { connect } from "react-redux";
import { createSelector } from "reselect";
import { ProtocolOptions as Component } from "./ProtocolOptions";

import {
  setTaskCompleted,
  incProtocolPage,
  decProtocolPage,
  goProtocolPage,
  setPageInstructions,
  toggleNotesView,
  setTotalProtocolPages,
  focusFirstTask,
  setModal,
  showModal,
  setViewedProtocolReadDialog,
} from "@learningblocks/protocol-redux/lib/Actions";

import { setChapter } from "@learningblocks/exp-redux";

function mapStateToProps(state) {
  return {
    currentPage: 1,
    totalPages: 99,
    pageInstructions: "",
    focusedTask: -1,
    focusedPage: -1,
    viewedProtocolReadDialog: false,
    level: 1,
    sectionOption: getCurrentSection(state.menuList),
    protocolMenuItem: getProtocolMenuItem(state.menuList),
    displayProgress: state.notebook.displayProgress ?? false,
    //modal: state.modal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // notebookSection: (data) => {
    //   dispatch(notebookSection(data))
    // },
    setTaskCompleted: (data) => {
      dispatch(setTaskCompleted(data));
    },
    focusFirstTask: (data) => {
      dispatch(focusFirstTask(data));
    },
    setNoteBookSection: (sectionValue) => {
      dispatch(setChapter(sectionValue));
    },

    incProtocolPage: (data) => {
      dispatch(incProtocolPage(data));
    },
    decProtocolPage: (data) => {
      dispatch(decProtocolPage(data));
    },
    goProtocolPage: (data) => {
      dispatch(goProtocolPage(data));
    },
    setPageInstructions: (data) => {
      dispatch(setPageInstructions(data));
    },
    setTotalProtocolPages: (data) => {
      dispatch(setTotalProtocolPages(data));
    },
    toggleNotesView: (data) => {
      dispatch(toggleNotesView(data));
    },
    setModal: (data) => {
      dispatch(setModal(data));
    },
    showModal: (data) => {
      dispatch(showModal(data));
    },
    setViewedProtocolReadDialog: (data) => {
      dispatch(setViewedProtocolReadDialog(data));
    },
  };
}

const currentSectionSelector = () => {
  return createSelector([(sections) => sections], (sections) =>
    sections.find((section) => section.current)
  );
};
const getCurrentSection = currentSectionSelector();

const protocolMenuItemSelector = () => {
  return createSelector([(menuList) => menuList], (menuList) =>
    menuList ? menuList.find((item) => item.value === "PROTOCOL") : null
  );
};
const getProtocolMenuItem = protocolMenuItemSelector();

export const ProtocolOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
